exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__BlockScreen__button {\n    width: 100%;\n    margin-top: 72px;\n}\n\n.DS__BlockScreen__block-wrapper {\n    display: flex;\n    flex-direction: column;\n}", ""]);

// exports
exports.locals = {
	"button": "DS__BlockScreen__button",
	"block-wrapper": "DS__BlockScreen__block-wrapper"
};